module.exports = __webpack_public_path__ + "static/media/gamesWon_100_250.f4f3ef06.png";